import { worldViewerWindow } from '../const';
import { getGyroActiveToggle, getVideoGainNode, setGyroActiveToggle } from './dataOps';
import { getVideo } from './domOps';
import { requestToToggleActivateGyro, sendGamepadData } from './moduleCaller';
/**
 * @remarks
 * Videoの音声をセット
 * @param volume {number}
 */ export const hel_video_SetVolume = (volume)=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    const gainNode = getVideoGainNode();
    if (gainNode === undefined) {
        // iOS/Mac以外ではgainNodeが生成されていなくてundefinedになるため、直接video要素に設定する
        video.volume = volume;
        return;
    }
    // worldViewerWindow.g_Video.volume = volume;
    gainNode.gain.value = volume;
};
const toggleGyroActive = ()=>{
    setGyroActiveToggle(!getGyroActiveToggle());
    requestToToggleActivateGyro();
    return getGyroActiveToggle();
};
/**
 * @remarks
 * ジャイロを変更
 * XRWorldIngame, JRWorld_web, WorldViewerにて未使用
 */ worldViewerWindow.toggleGyroActiveRequest = ()=>{
    if (getGyroActiveToggle()) {
        toggleGyroActive();
        return;
    }
    if (DeviceOrientationEvent && DeviceOrientationEvent.requestPermission && typeof DeviceOrientationEvent.requestPermission === 'function') {
        DeviceOrientationEvent.requestPermission().then((permissionState)=>{
            if (permissionState === 'granted') {
                toggleGyroActive();
            }
        }).catch(console.error);
    } else {
        toggleGyroActive();
    }
};
/**
 * ゲームパッドコントローラーを取得
 */ worldViewerWindow.g_gamepadController = {};
worldViewerWindow.getGamepadControllers = ()=>{
    if (worldViewerWindow.g_gamepadController == null) {
        return [];
    }
    return worldViewerWindow.g_gamepadController;
};
/**
 * ゲームパッドコントローラーを取得
 */ worldViewerWindow.g_gamepadController = [];
worldViewerWindow.getGamepadControllers = ()=>{
    return worldViewerWindow.g_gamepadController;
};
/**
 * ゲームパッドコントローラーInfoを取得
 */ worldViewerWindow.g_gamepadInfoArray = [];
worldViewerWindow.getGamepadInfoArray = ()=>{
    return worldViewerWindow.g_gamepadInfoArray;
};
const scanGamepads = ()=>{
    const controllers = worldViewerWindow.getGamepadControllers();
    const gamepads = navigator.getGamepads ? navigator.getGamepads() : navigator.webkitGetGamepads ? navigator.webkitGetGamepads() : [];
    for(let i = 0; i < gamepads.length; i++){
        if (gamepads[i] && gamepads[i].index in controllers) {
            controllers[gamepads[i].index] = gamepads[i];
        }
    }
};
export const updateGamepadsInfo = ()=>{
    // シーンファイルでusegamepadが有効になっていないのなら処理を行わない
    if (worldViewerWindow.hel_setText(worldViewerWindow.ETextParamType_IsUseGamePad, "") != 1) {
        return;
    }
    scanGamepads();
    const controllers = worldViewerWindow.getGamepadControllers();
    const gamepadInfoArray = worldViewerWindow.getGamepadInfoArray();
    for(let j in controllers){
        const controller = controllers[j];
        for(let i = 0; i < controller.buttons.length; i++){
            const val = controller.buttons[i];
            if (typeof val == "object") {
                var _gamepadInfoArray_j;
                gamepadInfoArray[j] = (_gamepadInfoArray_j = gamepadInfoArray[j]) !== null && _gamepadInfoArray_j !== void 0 ? _gamepadInfoArray_j : [];
                var _gamepadInfoArray_j_buttons;
                gamepadInfoArray[j].buttons = (_gamepadInfoArray_j_buttons = gamepadInfoArray[j].buttons) !== null && _gamepadInfoArray_j_buttons !== void 0 ? _gamepadInfoArray_j_buttons : [];
                var _gamepadInfoArray_j_buttons_i;
                gamepadInfoArray[j].buttons[i] = (_gamepadInfoArray_j_buttons_i = gamepadInfoArray[j].buttons[i]) !== null && _gamepadInfoArray_j_buttons_i !== void 0 ? _gamepadInfoArray_j_buttons_i : {};
                gamepadInfoArray[j].buttons[i].pressed = val.pressed;
                if ('touched' in val) {
                    gamepadInfoArray[j].buttons[i].touched = val.touched;
                }
                gamepadInfoArray[j].buttons[i].value = val.value;
            }
        }
        for(var i = 0; i < controller.axes.length; i++){
            var _gamepadInfoArray_j1;
            gamepadInfoArray[j] = (_gamepadInfoArray_j1 = gamepadInfoArray[j]) !== null && _gamepadInfoArray_j1 !== void 0 ? _gamepadInfoArray_j1 : [];
            var _gamepadInfoArray_j_axis;
            gamepadInfoArray[j].axis = (_gamepadInfoArray_j_axis = gamepadInfoArray[j].axis) !== null && _gamepadInfoArray_j_axis !== void 0 ? _gamepadInfoArray_j_axis : [];
            gamepadInfoArray[j].axis[i] = controller.axes[i];
        }
    }
    if (gamepadInfoArray[0] != null) {
        const gamepadInfo = gamepadInfoArray[0];
        var _gamepadInfo_buttons__value, _gamepadInfo_buttons__value1, _gamepadInfo_buttons__value2, _gamepadInfo_buttons__value3, _gamepadInfo_buttons__value4, _gamepadInfo_buttons__value5, _gamepadInfo_buttons__value6, _gamepadInfo_buttons__value7, _gamepadInfo_buttons__value8, _gamepadInfo_buttons__value9, _gamepadInfo_buttons__value10, _gamepadInfo_buttons__value11, _gamepadInfo_buttons__value12, _gamepadInfo_buttons__value13, _gamepadInfo_buttons__value14, _gamepadInfo_buttons__value15, _gamepadInfo_axis_, _gamepadInfo_axis_1, _gamepadInfo_axis_2, _gamepadInfo_axis_3;
        sendGamepadData(gamepadInfo.buttons.length >= 1 ? (_gamepadInfo_buttons__value = gamepadInfo.buttons[0].value) !== null && _gamepadInfo_buttons__value !== void 0 ? _gamepadInfo_buttons__value : 0 : 0, gamepadInfo.buttons.length >= 2 ? (_gamepadInfo_buttons__value1 = gamepadInfo.buttons[1].value) !== null && _gamepadInfo_buttons__value1 !== void 0 ? _gamepadInfo_buttons__value1 : 0 : 0, gamepadInfo.buttons.length >= 3 ? (_gamepadInfo_buttons__value2 = gamepadInfo.buttons[2].value) !== null && _gamepadInfo_buttons__value2 !== void 0 ? _gamepadInfo_buttons__value2 : 0 : 0, gamepadInfo.buttons.length >= 4 ? (_gamepadInfo_buttons__value3 = gamepadInfo.buttons[3].value) !== null && _gamepadInfo_buttons__value3 !== void 0 ? _gamepadInfo_buttons__value3 : 0 : 0, gamepadInfo.buttons.length >= 5 ? (_gamepadInfo_buttons__value4 = gamepadInfo.buttons[4].value) !== null && _gamepadInfo_buttons__value4 !== void 0 ? _gamepadInfo_buttons__value4 : 0 : 0, gamepadInfo.buttons.length >= 6 ? (_gamepadInfo_buttons__value5 = gamepadInfo.buttons[5].value) !== null && _gamepadInfo_buttons__value5 !== void 0 ? _gamepadInfo_buttons__value5 : 0 : 0, gamepadInfo.buttons.length >= 7 ? (_gamepadInfo_buttons__value6 = gamepadInfo.buttons[6].value) !== null && _gamepadInfo_buttons__value6 !== void 0 ? _gamepadInfo_buttons__value6 : 0 : 0, gamepadInfo.buttons.length >= 8 ? (_gamepadInfo_buttons__value7 = gamepadInfo.buttons[7].value) !== null && _gamepadInfo_buttons__value7 !== void 0 ? _gamepadInfo_buttons__value7 : 0 : 0, gamepadInfo.buttons.length >= 9 ? (_gamepadInfo_buttons__value8 = gamepadInfo.buttons[8].value) !== null && _gamepadInfo_buttons__value8 !== void 0 ? _gamepadInfo_buttons__value8 : 0 : 0, gamepadInfo.buttons.length >= 10 ? (_gamepadInfo_buttons__value9 = gamepadInfo.buttons[9].value) !== null && _gamepadInfo_buttons__value9 !== void 0 ? _gamepadInfo_buttons__value9 : 0 : 0, gamepadInfo.buttons.length >= 11 ? (_gamepadInfo_buttons__value10 = gamepadInfo.buttons[10].value) !== null && _gamepadInfo_buttons__value10 !== void 0 ? _gamepadInfo_buttons__value10 : 0 : 0, gamepadInfo.buttons.length >= 12 ? (_gamepadInfo_buttons__value11 = gamepadInfo.buttons[11].value) !== null && _gamepadInfo_buttons__value11 !== void 0 ? _gamepadInfo_buttons__value11 : 0 : 0, gamepadInfo.buttons.length >= 13 ? (_gamepadInfo_buttons__value12 = gamepadInfo.buttons[12].value) !== null && _gamepadInfo_buttons__value12 !== void 0 ? _gamepadInfo_buttons__value12 : 0 : 0, gamepadInfo.buttons.length >= 14 ? (_gamepadInfo_buttons__value13 = gamepadInfo.buttons[13].value) !== null && _gamepadInfo_buttons__value13 !== void 0 ? _gamepadInfo_buttons__value13 : 0 : 0, gamepadInfo.buttons.length >= 15 ? (_gamepadInfo_buttons__value14 = gamepadInfo.buttons[14].value) !== null && _gamepadInfo_buttons__value14 !== void 0 ? _gamepadInfo_buttons__value14 : 0 : 0, gamepadInfo.buttons.length >= 16 ? (_gamepadInfo_buttons__value15 = gamepadInfo.buttons[15].value) !== null && _gamepadInfo_buttons__value15 !== void 0 ? _gamepadInfo_buttons__value15 : 0 : 0, gamepadInfo.axis.length >= 1 ? (_gamepadInfo_axis_ = gamepadInfo.axis[0]) !== null && _gamepadInfo_axis_ !== void 0 ? _gamepadInfo_axis_ : 0 : 0, gamepadInfo.axis.length >= 2 ? (_gamepadInfo_axis_1 = gamepadInfo.axis[1]) !== null && _gamepadInfo_axis_1 !== void 0 ? _gamepadInfo_axis_1 : 0 : 0, gamepadInfo.axis.length >= 3 ? (_gamepadInfo_axis_2 = gamepadInfo.axis[2]) !== null && _gamepadInfo_axis_2 !== void 0 ? _gamepadInfo_axis_2 : 0 : 0, gamepadInfo.axis.length >= 4 ? (_gamepadInfo_axis_3 = gamepadInfo.axis[3]) !== null && _gamepadInfo_axis_3 !== void 0 ? _gamepadInfo_axis_3 : 0 : 0);
    }
};
const addGamepad = (e)=>{
    const controllers = worldViewerWindow.getGamepadControllers();
    controllers[e.gamepad.index] = e.gamepad;
};
const removeGamepad = (e)=>{
    const controllers = worldViewerWindow.getGamepadControllers();
    const gamepadInfoArray = worldViewerWindow.getGamepadInfoArray();
    delete controllers[e.gamepad.index];
    delete gamepadInfoArray[e.gamepad.index];
};
/**
 * @remarks
 * ゲームパッドを扱う
 */ export const initializeGamePad = ()=>{
    if ('GamepadEvent' in window) {
        window.addEventListener("gamepadconnected", addGamepad);
        window.addEventListener("gamepaddisconnected", removeGamepad);
    } else if ('WebKitGamepadEvent' in window) {
        window.addEventListener("webkitgamepadconnected", addGamepad);
        window.addEventListener("webkitgamepaddisconnected", removeGamepad);
    }
};
